export * from "vuex-simple";
export { AppStore as RootModule } from "@/store/store";
export * from "vue-property-decorator";
//Тесты
//https://stackoverflow.com/questions/43176006/typeerror-class-extends-value-undefined-is-not-a-function-or-null;
//import { Component, Emit, Prop, Vue } from "vue-property-decorator";
